import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { memberremove, postdetails } from "../../services/Mainservice";
import { Cross, X } from "lucide-react";
import Loader from "../../Loader/Loader";

const PostDetails = () => {
  const [loading, setloading] = useState(false);
  const [data, setData] = useState({});
  const location = useLocation();

  const navigate = useNavigate();

  const id = location.state.id;

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, [id]);

  const getData = async (id) => {
    console.log();
    try {
      setloading(true);
      const response = await postdetails(id);
      console.log(response.data.data[0]);
      setData(response.data.data[0]);

      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const removemember = async (id) => {
    try {
      const response = await memberremove(data.id, id);
      getData(id);
      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <h1 className="userdetails_heading">Post Details </h1>
      <div className="userdetails">
        <div className="userdetails_up">
          <div className="userprofile_up2">
            <div className="postprofile_up_imglist">
              <img src={data.image} alt="img" />
            </div>

            <h1 className="username">{data.CreatedBy}</h1>
          </div>
        </div>
        <div className="userdetails_down">
          <p className="userdata">
            Post Create: <span> {data.createdAt}</span>
          </p>
          <p className="userdata">
            Title: <span> {data.Title}</span>
          </p>
          <p className="userdata">
            Description: <span> {data.Description}</span>
          </p>
          <p className="userdata">
            Location: <span> {data.Location}</span>
          </p>
          <p className="userdata">
            Date: <span> {data.date}</span>
          </p>
          <p className="userdata">
            Time:{" "}
            <span>
              {data?.Time}-{data?.endTime}
            </span>
          </p>
          <p className="userdata">
            Group Size:{" "}
            <span>
              {" "}
              {data?.joinedCount}/{data.GroupSize}
            </span>
          </p>

          <p className="userdata">
            Available Now:{" "}
            <span>{data.isAvailablenow === true ? "Yes" : "No"}</span>
          </p>

          <p className="userdata">
            Status:{" "}
            <span>
              {data.status === "closed" ? (
                <span className="cancel_data">{data.status}</span>
              ) : (
                <span className="complete_data">{data.status}</span>
              )}
            </span>
          </p>
        </div>
      </div>

      <h1 className="userdetails_heading">Members </h1>

      <div className="chatuserslist">
        {data?.members?.length > 0 ? (
          <>
            {data.members?.map((i, index) => (
              <div
                className="user_chatprofile"
                onClick={() =>
                  navigate("/User_Details", {
                    state: {
                      id: i,
                    },
                  })
                }
              >
                <div className="post_member_profile">
                  <img src={i.image} />
                  <p>{i.name}</p>
                </div>
                <X
                  onClick={(e) => {
                    e.stopPropagation();
                    removemember(i.id);
                  }}
                  style={{ cursor: "pointer" }}
                />
              </div>
            ))}
          </>
        ) : (
          <p className="nodata">No Members Joint Yet</p>
        )}
      </div>
      {loading && <Loader />}

      {/* <Notes isOpen={note} setisOpen={setnote} handledelete={handleaction} /> */}
      {/* {data.device_token ? (
        <div className="user_notification">
          <PushNotification id={data.device_token} />
        </div>
      ) : (
        ""
      )} */}
    </>
  );
};
export default PostDetails;
